// eslint-disable-next-line import/prefer-default-export
export const FLAG_TOTAL_POS_ACTIVITY = 'FLAG_TOTAL_POS_ACTIVITY';
